import produce from 'immer';

const INITIAL_STATE = { token: null, signed: false, loading: false };

export default function patient(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@patient/SIGN_IN_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@patient/SIGN_IN_SUCCESS': {
        draft.token = action.payload.token;
        draft.patient = action.payload.patient;
        draft.signed = true;
        draft.loading = false;
        break;
      }
      case '@patient/SIGN_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@patient/SIGN_OUT': {
        draft.token = null;
        draft.signed = false;
        draft.patient = null;
        break;
      }
      default:
    }
  });
}
